import { render, staticRenderFns } from "./Lgx02654289120261633474593.vue?vue&type=template&id=c544afd8&"
import script from "./Lgx02654289120261633474593.vue?vue&type=script&lang=js&"
export * from "./Lgx02654289120261633474593.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02654289120261633474593.vue?vue&type=style&index=0&id=c544afd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports